var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.productGroups),function(group,index){return _c('product-group-menu-tile',{key:index,attrs:{"product-group":group}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }